<div *ngIf="!list && !deleteconfirm">
  <div *ngFor="let orgfile of filelist" class="row mb-2 ml-0">
    <div matTooltip="{{ 'filelist.download' | trans }} {{fileBaseName(orgfile.filename) | slice:37:52}}" mattooltipposition="above"
      mattooltipshowdelay="500" (click)="getSignedUrl(orgfile)" class="col-8 pl-0">
      <p class=" cursor-pointer mb-0 hover-text" [ngClass]="{'text-black': textColor, 'text-white': !textColor }">
        <span class="float-left material-icons cursor-pointer" style="font-size:20px;">
          attach_file
        </span>{{fileBaseName(orgfile.filename) | slice:37:52}}
      </p>
    </div>
    <div class="col-4 cursor-pointer flex-row-reverse">
      <button class="btn btn-task border-0 bg-transparent p-0 cursor-pointer">
        <!-- <a href="{{orgfile.fileurl}}" download="{{orgfile.filename}}" class="float-left material-icons download-button cursor-pointer" style="font-size:20px; margin-left:5px; cursor: pointer!important;">
        file_download
      </a> -->
        <!---<a class="float-left material-icons download-button cursor-pointer" style="font-size:20px; margin-left:5px; cursor: pointer!important;" (click)="getSignedUrl(orgfile)">
        file_download
      </a>--->
      </button>
      <!---List multi type start delete-->
      <button class="btn btn-task border-0 bg-transparent p-0 cursor-pointer"
        *ngIf="candeletefile(orgfile) && togglertasklistfiles == null && viewtype == 'modal'"
        (click)="toggletaskfilelist(orgfile)">
        <span class="float-left material-icons download-button-modal cursor-pointer f-20 ml-1">
          delete
        </span>
      </button>
      <!---List multi type end delete-->
      <button class="btn btn-task border-0 bg-transparent p-0 cursor-pointer"
        *ngIf="candeletefile(orgfile) && togglertasklistfiles == null && viewtype != 'modal'"
        (click)="toggletaskfilelist(orgfile)">
        <span class="float-left material-icons download-button cursor-pointer f-20 ml-1">
          delete
        </span>
      </button>
      <button *ngIf="candeletefile(orgfile) && togglertasklistfiles == orgfile.fileId && viewtype != 'modal'"
        class="btn btn-task border-0 bg-transparent p-0 cursor-pointer" (click)="toggletaskfilelistoff()"
        matTooltip="{{ 'filelist.cancel' | trans }}" mattooltipposition="above" mattooltipshowdelay="500">
        <span class="float-left material-icons download-button cursor-pointer f-20 ml-1">
          close
        </span>
      </button>
      <button *ngIf="candeletefile(orgfile) && togglertasklistfiles == orgfile.fileId && viewtype != 'modal'"
        class="btn btn-task border-0 bg-transparent p-0 cursor-pointer" (click)="deleteFile(orgfile)"
        matTooltip="{{ 'filelist.confirm' | trans }}" mattooltipposition="above" mattooltipshowdelay="500">
        <span class="float-left material-icons download-button cursor-pointer f-20 ml-1">
          check
        </span>
      </button>
      <!---modal type confirm start-->
      <button *ngIf="candeletefile(orgfile) && togglertasklistfiles == orgfile.fileId && viewtype == 'modal'"
        class="btn btn-task border-0 bg-transparent p-0 cursor-pointer" (click)="toggletaskfilelistoff()"
        matTooltip="{{ 'filelist.cancel' | trans }}" mattooltipposition="above" mattooltipshowdelay="500">
        <span class="float-left material-icons download-button-modal cursor-pointer f-20 ml-1">
          close
        </span>
      </button>
      <button *ngIf="candeletefile(orgfile) && togglertasklistfiles == orgfile.fileId && viewtype == 'modal'"
        class="btn btn-task border-0 bg-transparent p-0 cursor-pointer" (click)="deleteFile(orgfile)"
        matTooltip="{{ 'filelist.confirm' | trans }}" mattooltipposition="above" mattooltipshowdelay="500">
        <span class="float-left material-icons download-button-modal cursor-pointer f-20 ml-1">
          check
        </span>
      </button>
      <!---modal type confirm end-->

    </div>
  </div>
</div>
<div *ngIf="list && !deleteconfirm">
  <ng-container *ngIf="modal">
    <div style="margin-top:-18px!important;" class="row pb-2">
      <div class="col">
        <ng-container *ngIf="!modal">
          <h6 class="f-15 font-weight-light">{{ 'filelist.files' | trans }}</h6>
        </ng-container>
        <span data-toggle="collapse" data-target=".multi-collapse" aria-expanded="false"
          aria-controls="collapseProjectsList collapseProjectList"
          style="border-radius: 0px 0px 10px 10px !important; border: 1px solid #dee2e6;"
          class="material-icons portal-icon btn btn-secondary center transistion align-middle p-0 w-35 h-35 lh-35">
          filter_alt </span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!modal">
    <div class="row pb-2">
      <div class="col">
        <ng-container *ngIf="!modal">
          <h6 class="f-15 font-weight-light">{{ 'filelist.files' | trans }}</h6>
        </ng-container>
        <a matTooltip="{{ 'filelist.showcustomerproject' | trans }}" mattooltipposition="above"
          mattooltipshowdelay="500" class="mat-tooltip-trigger cursor-pointer ng-star-inserted"
          style="position: absolute; right: 45px; top: -5px; z-index: 1000;" ng-reflect-position="above"
          data-toggle="collapse" data-target=".multi-collapse" aria-expanded="false"
          aria-controls="collapseProjectsList collapseProjectList" aria-describedby="cdk-describedby-message-25"
          cdk-describedby-host="">
          <span _ngcontent-tye-c148=""
            class="material-icons f-20 opacity w-30 text-center lh-30 align-middle rounded-circle cursor-pointer bg-lightgrey text-muted">
            filter_alt </span>
        </a>
        <!-- 
        <span data-toggle="collapse" data-target=".multi-collapse" aria-expanded="false" aria-controls="collapseProjectsList collapseProjectList"
        style="border-radius: 0px 0px 10px 10px !important; border: 1px solid #dee2e6; position: absolute; top:-10px; right:80px;"
        class="material-icons portal-icon btn btn-secondary center transistion align-middle p-0 w-35 h-35 lh-35"> filter_alt </span> -->
      </div>
    </div>
  </ng-container>



  <div *ngIf="activeFilters.length > 0" class="card bg-secondary card-body p-2 mb-2 pr-3">
    <div class="row">
      <div class="col">
        <p class="mb-0 lh-35 align-middle font-weight-light">{{ 'filelist.activefilter' | trans }}</p>
      </div>
      <div *ngFor="let af of activeFilters" class="col-auto pl-0 pr-2">
        <button class="btn" (click)="removeFromFilter(af)">
          <p class="btn-text cursor-pointer">{{af.title}}
            <span class="material-icons f-15 align-middle">
              close
            </span>
          </p>
        </button>
      </div>
    </div>
  </div>





  <div class="collapse multi-collapse fade" id="collapseProjectsList">

    <div class="row">
      <div class="col">
        <div class="card p-1 pt-2 bg-secondary card-body">
          <div class="row">
            <div class="col">
              <div class="form-group p-2 mb-0">
                <input id="search" class="form-control" placeholder="{{ 'filelist.activefilter' | trans }}" typetofilter
                  [(ngModel)]="filtertext">
              </div>
            </div>
          </div>
          <p class="mb-0">{{ 'filelist.projectslist' | trans }}</p>
        </div>
        <ul class="list-group">
          <li *ngFor="let p of filteredfilter | appFilter: filtertext" class="list-group-item"
            (click)="addToFilter(p.entity)">
            <p class="mb-0" appHighlight [searchedWord]="filtertext" [content]="p.title"
              [classToApply]="'font-weight-bold'" [setTitle]="'true'"></p>
          </li>

        </ul>
      </div>
    </div>
  </div>


  <div class="multi-collapse collapse show fade" id="collapseProjectList">
    <div class="row">
      <div class="col-4">
        <p class="mb-0 text-muted font-weight-lighter">{{ 'filelist.name' | trans }}</p>
      </div>
      <div class="col-3">
        <p class="mb-0 text-muted font-weight-lighter">{{ 'filelist.project' | trans }}</p>
      </div>
      <div class="col-2">
        <p class="mb-0 text-muted font-weight-lighter">{{ 'filelist.uploaded' | trans }}</p>
      </div>
      <div class="col-3">
        <p class="mb-0 text-muted font-weight-lighter ">{{ 'filelist.actions' | trans }}</p>
      </div>
    </div>
    <div *ngIf="showNoFilesMsg" class="row">
      <div class="col">
        <p class="mb-0 text-truncate align-middle lh-33">{{ 'filelist.nofilesavailable' | trans }}</p>
      </div>
    </div>
    <div *ngFor="let file of filteredfilelist" class="row">
      <div class="col-4">
        <p class="mb-0 text-truncate align-middle lh-33">{{ fileBaseName(file.filename).substring(37) }}</p>
      </div>
      <div class="col-3">
        <p class="mb-0 text-truncate align-middle lh-33"><app-projectname
            [projectId]="file.projectId"></app-projectname></p>
      </div>
      <div class="col-2">
        <p class="mb-0 text-truncate align-middle lh-33">{{ file.uploaddate | date:'yyyy-MM-dd' }}</p>
      </div>
      <div *ngIf="toggledeletefile == file.fileId" class="col-3 align-middle lh-33">
        <a (click)="fileToggleof()" class="cursor-pointer" matTooltip="{{ 'filelist.goback' | trans }}"
          matTooltipPosition="above" matTooltipShowDelay="500" *ngIf="candeletefile(file)">
          <span class="material-icons f-20 opacity p-1 align-middle rounded-circle cursor-pointer bg-save text-light">
            undo
          </span>
        </a>
        <a class="cursor-pointer ml-2" matTooltip="{{ 'filelist.deletefile' | trans }}" matTooltipPosition="above"
          matTooltipShowDelay="500" *ngIf="candeletefile(file)" (click)="toggleDelete(file)">
          <span class="material-icons f-20 opacity p-1 align-middle rounded-circle cursor-pointer bg-close text-light">
            check
          </span>
        </a>
      </div>
      <div *ngIf="toggledeletefile == null" class="col-3 align-middle ">
        <!--<a class="cursor-pointer" href="{{file.fileurl}}" download="{{file.filename.substring(37)}}"
          matTooltip="Download file"  matTooltipPosition="above" matTooltipShowDelay="500">-->
        <a class="cursor-pointer" (click)="getSignedUrl(file)" matTooltip="{{ 'filelist.downloadfile' | trans }}"
          matTooltipPosition="above" matTooltipShowDelay="500">
          <span
            class="material-icons f-20 opacity p-1  align-middle rounded-circle cursor-pointer bg-lightgrey text-muted">
            download
          </span>
        </a>
        <a class="cursor-pointer ml-2" matTooltip="{{ 'filelist.deletefile' | trans }}" matTooltipPosition="above"
          matTooltipShowDelay="500" *ngIf="candeletefile(file)" (click)="fileToggle(file)">
          <span
            class="material-icons f-20 opacity p-1  align-middle rounded-circle cursor-pointer bg-lightgrey text-muted">
            delete
          </span>
        </a>
        <a class="cursor-pointer ml-2" matTooltip="{{ 'filelist.showinproject' | trans }}" matTooltipPosition="above"
          matTooltipShowDelay="500" (click)="navigate(file.projectId)" data-dismiss="modal">
          <span
            class="material-icons f-20 opacity p-1  align-middle rounded-circle cursor-pointer bg-lightgrey text-muted">
            launch
          </span>
        </a>
      </div>
    </div>
  </div>

</div>
<div *ngIf="deleteconfirm">
  <div class="row">
    <div class="col">
      <p class="text-center">{{ 'filelist.pleaseconfirm' | trans }}{{ fileBaseName(fileToDelete?.filename).substring(37) }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <button (click)="toggleDelete()" class="btn-close">
        <h6 class="btn-save-text">{{ 'filelist.cancel' | trans }}</h6>
      </button>
    </div>
    <div class="col">
      <button (click)="deleteFile()" class="btn-save">
        <h6 class="btn-save-text">{{ 'filelist.confirmdelete' | trans }}</h6>
      </button>
    </div>
  </div>

</div>